module.exports = __webpack_public_path__ + "static/media/achievements-icon.0f4db416.svg";